import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import Product2 from "../components/Product2";
import OrderAddCard from "./OrderAddCard"
import OrderCoupon from "./OrderCoupon"
import OrderModifyOrderer from "./OrderModifyOrderer"
import DelivManagement from "./DelivManagement"

import { BsX, BsPlusLg, BsWallet, BsFillPenFill, BsDatabaseFill, BsTags, BsCreditCard, BsChevronRight, BsCashStack, BsFillTrashFill, BsBank2 } from "react-icons/bs";
import point from "../images/point.svg";
import Accordion from 'react-bootstrap/Accordion';
import { Link, useNavigate, useLocation  } from "react-router-dom";
import { useAxios } from "../services/useAxios";
import Nodata from "../components/NoData";
import Modal from 'react-bootstrap/Modal';

import naverPay from "../images/naverPay.png";
import kakaoPay from "../images/kakaoPay.png";
import ssPay from "../images/ssPay.png";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export default function Order(){
    const navigate = useNavigate();
    const { t } = useTranslation();
    const userInfo = JSON.parse(localStorage.getItem("user")).data;

    const [isEsayPassOpen, setEsayPassOpen] = useState(false);
    const [isCardOpen, setCardOpen] = useState(false);
    const [isCashRcptOpen, setCashRcptOpen] = useState(false);
    const [isOrdererOpen, setOrdererOpen] = useState(false);    
    const [isCouponOpen, setCouponOpen] = useState(false);
    const [isDelivOpen, setDelivOpen] = useState(false);
    const [isAgr, setAgr] = useState(false);
    
    let paramData = useLocation();
    
    const [data, setData] = useState({});
    const [ordererInfo, setOrdererInfo] = useState(userInfo);
    const [dlvyInfo, setDlvyInfo] = useState({});
    const [couponInfo, setCouponInfo] = useState({});
    const [cardInfo, setCardInfo] = useState({payMethod:"va"});
    const [selMemo, setSelMemo] = useState('');
    const [useMileage, setUseMileage] = useState(0);
    const [dlvyMemo, setDlvyMemo] = useState('');
    const [request] = useAxios();
    const [dlvyCtAmount, setDlvyCtAmount] = useState(0);
    const [cashRcptTy, setCashRcptTy] = useState(1);
    const [cashRcptTy2, setCashRcptTy2] = useState(1);
    const [easyCardList, setEasyCardList] = useState([]);
    const [seltEasyCardInfo, setSeltEasyCardInfo] = useState({});
    const lang = localStorage.getItem("language") || "ko";

    const [activeTab, setActiveTab] = useState("");
    const phoneInput1 = useRef()
    const phoneInput2 = useRef()
    const phoneInput3 = useRef()

    const cardInput1 = useRef()
    const cardInput2 = useRef()
    const cardInput3 = useRef()
    const cardInput4 = useRef()


    const passInput1 = useRef()
    const passInput2 = useRef()
    const passInput3 = useRef()
    const passInput4 = useRef()

    const bizrnoInput1 = useRef()
    const bizrnoInput2 = useRef()
    const bizrnoInput3 = useRef()

    const cashRcptUseAt = useRef()

    const cardQuota = useRef()
    
    const fn_order = () => {        
        if(!ordererInfo.userNm || !ordererInfo.telno || !ordererInfo.email){
            setOrdererOpen(true);         
            return;
        }

        if(!dlvyInfo || !dlvyInfo.dlvyInfoSn){
            alert(t(`Message.payment_button_required_dlvy_info`))
            return
        }

        if(cardInfo.payMethod === null || cardInfo.payMethod === ''){
            alert(t(`Message.payment_button_required_pay_method`))
            return
        }

        if(!isAgr){
            alert(t(`Message.payment_button_order_cn_confirm`))
            return
        }
        if(cardInfo.payMethod === 'billing'){
            if(!seltEasyCardInfo.billingSn){
                alert('선택된 카드가 없습니다.')
                return
            }else{
                setEsayPassOpen(true)
            }
        }else if(cardInfo.payMethod === 'va'){        
            let cashRcptPubNo = '';

            if(ordererInfo.userNm.length <= 1){
                setOrdererOpen(true);     
                alert('주문자 이름은 최소 1글자 이상이여합니다. ')
                return
            }

            if(activeTab === 'apply' && isCashRcptOpen){            
                
                if(cashRcptTy === 1){                    
                    if(cashRcptTy2 === 1){
                        cashRcptPubNo = phoneInput1.current.value+phoneInput2.current.value+phoneInput3.current.value
                        
                        var regPhoneValid = /^010-?([0-9]{4})-?([0-9]{4})$/;
                        if(!regPhoneValid.test(cashRcptPubNo)){
                            alert('정확한 휴대폰번호를 입력해주세요.')
                            return
                        }

                    }else{
                        cashRcptPubNo = cardInput1.current.value+cardInput2.current.value+cardInput3.current.value+cardInput4.current.value
                                                
                        if(!fn_validCardNum(cashRcptPubNo)){
                            alert('정확한 현금영수증 카드번호를 입력해주세요.')
                            return
                        }

                    }
                }else{
                    cashRcptPubNo = bizrnoInput1.current.value+bizrnoInput2.current.value+bizrnoInput3.current.value
                    if(!fn_validBizrno(cashRcptPubNo)){
                        alert('정확한 사업자번호를 입력해주세요.')
                        return
                    }
                }
            }

            if(activeTab === 'noApply'){
                ordererInfo.cashRcptAt = 'N';
                ordererInfo.cashRcptPubType = '';
                ordererInfo.cashRcptPubNoType = '';
                ordererInfo.cashRcptPubNo = '';
                
            }else{
                if(isCashRcptOpen){
                    ordererInfo.cashRcptAt = 'Y';
                    ordererInfo.cashRcptPubType = cashRcptTy;
                    ordererInfo.cashRcptPubNoType = cashRcptTy2;
                    ordererInfo.cashRcptPubNo = cashRcptPubNo;                   
                }
            }
            ordererInfo.cashRcptUseAt = cashRcptUseAt?"Y":"N";
            fn_shinhanPay();
        }else{
            fn_Nicepay()
        }

          
    }

    const fn_removeEasyCard = async (easyCard) => {
        const result = await confirm('등록된 카드를 삭제하시겠습니까?', {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            easyCard.orderId = data.tmprOrderId
            const response = await request.post("/app/order/removeSimpleCardBillingAPI",easyCard);        
            if(response.data.resultCode === 200){
                alert(response.data.resultMessage)
                setEasyCardList(response.data.result.billingList)
                setSeltEasyCardInfo({})      
            }else{
                alert(response.data.resultMessage)
            }
        }
    }

    const fn_validCardNum = (card) =>{
        if(card === null || card.length <13){
            return false
        }
        return true;
    }

    const fn_validBizrno = (bizrno) =>{
        var numberMap = bizrno.replace(/-/gi, '').split('').map(function (d){
            return parseInt(d, 10);
        });

        if(numberMap.length === 10){
            var keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
            var chk = 0;

            keyArr.forEach(function(d, i){
                chk += d * numberMap[i];
            });

            chk += parseInt((keyArr[8] * numberMap[8])/ 10, 10);
            return true;
        }

        return false;
    }

    const fn_Billing = async () => {

        const passwd = passInput1.current.value+passInput2.current.value+passInput3.current.value+passInput4.current.value
        if(passwd === null || passwd.length <4){
            alert('비밀번호 4자리를 입력해주세요.')
            return
        }

        const response3 = await request.post("/app/order/getBillingAndPaymentAPI",{
            billingSn: seltEasyCardInfo.billingSn,
            billingPassword : passwd  
        });        
        if(response3.data.resultCode === 200){

            const response = await request.post("/app/order/orderPaymentBeforeAPI", {
                lastSetleAmount : (data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)),
                dlvyCtAmount : dlvyCtAmount,
                extraDlvyCtAmount : dlvyInfo.extraDlvyCtAmount,
                tmprOrderId: data.tmprOrderId,
                cartAt : data.cartAt,
                payMethod : cardInfo.payMethod,
                pgCode :'nicepay',
                useEscrow : 'false',
                vbankHolder :'',
                ordrrNm : ordererInfo.userNm,
                ordrrTelno :ordererInfo.telno,
                ordrrEmailAdres : ordererInfo.email,
                recptrNm : dlvyInfo.dlvyInfoNm,
                recptrCttpc :dlvyInfo.dlvyCttpc,
                recptrZip :dlvyInfo.dlvyZip,
                recptrBassAdres :dlvyInfo.dlvyBassAdres,
                recptrDetailAdres :dlvyInfo.dlvyDetailAdres,
                recptrDlvyInfoSn : dlvyInfo.dlvyInfoSn,
                dlvyMemo : dlvyMemo,
                entrncPass : dlvyInfo.dlvyEntrncPass,
                useCouponIssuHistSn : couponInfo.couponIssuHistSn,
                mlgUseAmount : useMileage
    
            });
            
            if(response.data.resultCode === 200){
                
                const orderSheetVO = response.data.result.orderSheetVO;
                const response2 = await request.post("/app/order/addBillingAndPaymentAPI",{
                    billingSn: seltEasyCardInfo.billingSn,
                    billingPassword : passwd,
                    cardQuota : cardQuota.current.value,
                    goodsName:data.goodsName.substr(0,39),
                    orderId : orderSheetVO.orderNo
                });        
                if(response2.data.resultCode === 200){
                    window.location.href="/OrderFin?id="+orderSheetVO.orderNo+"&resultCode=0000"
                    return
                }else{
                    const mallReserved ={
                        orderSn : orderSheetVO.orderSn,
                        tmprOrderId : orderSheetVO.tmprOrderId,
                        userId : orderSheetVO.userId,
                        useCouponIssuHistSn : orderSheetVO.useCouponIssuHistSn,
                        failRedirect :''
                    }
                    const response = await request.post("/app/order/orderPaymentBeforeCancelAPI", mallReserved);                   
                    if(response.data.resultCode !== 200){
                        alert(response.data.resultMessage)
                    }
                }                        
            }
        }else{
            alert(response3.data.resultMessage)
        }
    }

    const fn_shinhanPay = async () => {
        const response = await request.post("/app/order/procVirtualAccountPaymentAPI", {
            lastSetleAmount : (data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)),
            dlvyCtAmount : dlvyCtAmount,
            extraDlvyCtAmount : dlvyInfo.extraDlvyCtAmount,
            tmprOrderId: data.tmprOrderId,
            cartAt : data.cartAt,
            payMethod : cardInfo.payMethod,
            pgCode :'shinhan',
            useEscrow : 'false',
            vbankHolder :ordererInfo.userNm,
            ordrrNm : ordererInfo.userNm,
            ordrrTelno :ordererInfo.telno,
            ordrrEmailAdres : ordererInfo.email,
            recptrNm : dlvyInfo.dlvyInfoNm,
            recptrCttpc :dlvyInfo.dlvyCttpc,
            recptrZip :dlvyInfo.dlvyZip,
            recptrBassAdres :dlvyInfo.dlvyBassAdres,
            recptrDetailAdres :dlvyInfo.dlvyDetailAdres,
            recptrDlvyInfoSn : dlvyInfo.dlvyInfoSn,
            dlvyMemo : dlvyMemo,
            entrncPass : dlvyInfo.dlvyEntrncPass,
            useCouponIssuHistSn : couponInfo.couponIssuHistSn,
            mlgUseAmount : useMileage,
            goodsName: data.goodsName.substr(0,39),
            cashRcptAt : ordererInfo.cashRcptAt,
            cashRcptPubType : ordererInfo.cashRcptPubType,
            cashRcptPubNoType : ordererInfo.cashRcptPubNoType,
            cashRcptPubNo : ordererInfo.cashRcptPubNo,
            cashRcptUseAt : ordererInfo.cashRcptUseAt
        });       
        if(response.data.resultCode === 200){
            window.location.href="/OrderFin?id="+response.data.result.orderSheetVO.orderNo+"&resultCode=0000"
        }


        
    }

    const fn_Nicepay = async () => {
        
        const response = await request.post("/app/order/orderPaymentBeforeAPI", {
            lastSetleAmount : (data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)),
            dlvyCtAmount : dlvyCtAmount,
            extraDlvyCtAmount : dlvyInfo.extraDlvyCtAmount,
            tmprOrderId: data.tmprOrderId,
            cartAt : data.cartAt,
            payMethod : cardInfo.payMethod,
            pgCode :'nicepay',
            useEscrow : 'false',
            vbankHolder :'',
            ordrrNm : ordererInfo.userNm,
            ordrrTelno :ordererInfo.telno,
            ordrrEmailAdres : ordererInfo.email,
            recptrNm : dlvyInfo.dlvyInfoNm,
            recptrCttpc :dlvyInfo.dlvyCttpc,
            recptrZip :dlvyInfo.dlvyZip,
            recptrBassAdres :dlvyInfo.dlvyBassAdres,
            recptrDetailAdres :dlvyInfo.dlvyDetailAdres,
            recptrDlvyInfoSn : dlvyInfo.dlvyInfoSn,
            dlvyMemo : dlvyMemo,
            entrncPass : dlvyInfo.dlvyEntrncPass,
            useCouponIssuHistSn : couponInfo.couponIssuHistSn,
            mlgUseAmount : useMileage

        });
        
        if(response.data.resultCode === 200){
            const orderSheetVO = response.data.result.orderSheetVO;
            const mallReserved ={
                orderSn : orderSheetVO.orderSn,
                tmprOrderId : orderSheetVO.tmprOrderId,
                userId : orderSheetVO.userId,
                useCouponIssuHistSn : orderSheetVO.useCouponIssuHistSn,
                failRedirect :''
            }
            window.AUTHNICE.requestPay({
                clientId: 'R2_e9e3875aca424fd1a5fde2945291b8d8',
                method: cardInfo.payMethod,
                orderId : orderSheetVO.orderNo,
                amount :(data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)),
                goodsName: data.goodsName.substr(0,39),
                buyerName:ordererInfo.userNm,
                buyerTel :ordererInfo.telno.replace(/-/g,''),
                buyerEmail : ordererInfo.email,
                returnUrl: 'https://www.salee.co.kr/nicepay/payment/result',
                mallReserved: JSON.stringify(mallReserved),
                useEscrow: false,

                fnError: async function (result) {
                    const response = await request.post("/app/order/orderPaymentBeforeCancelAPI", mallReserved);
                   
                    if(response.data.resultCode !== 200){
                       alert(response.data.resultMessage)
                    }
                }
              });       
            
        }
        


       
    }

    const fetchData = async () => {
        
        const response = await request.post("/app/order/createOrderSheetAPI",{ 'cartList': paramData.state.from, 'nationSeCode':lang});
        
        if(response.data.resultCode === 200){
            setData(response.data.result);
            setDlvyInfo(response.data.result.dlvyInfo);
            setDlvyCtAmount(response.data.result.dlvyPrice + ((response.data.result.dlvyInfo?response.data.result.dlvyInfo.extraDlvyCtAmount:0) * 1))
            setOrdererInfo(response.data.result.ordrrInfoVO)    
            setCashRcptTy(response.data.result.ordrrInfoVO?.cashRcptPubType!==2?1:2) 
            setCashRcptTy2(response.data.result.ordrrInfoVO?.cashRcptPubNoType!==2?1:2) 
            setEasyCardList(response.data.result.easyCardList)
            setActiveTab(response.data.result.ordrrInfoVO?.cashRcptAt==="Y"?"apply":"noApply")
            
        }else{
            if(response.data.result.goodsNm){
                await alert("["+response.data.result.goodsNm+"] \n 구매가능개수를 초과하였습니다. 구매 가능 개수는 " +response.data.result.buyPossCnt  +"개 입니다." )
                navigate(-1);

            }else{
                await alert(response.data.resultMessage)
                window.location.href = "/"
            }
            
        }
    };

    const handleSelect = (e) => {
        setSelMemo(e.target.value);
        if( e.target.value === 'etc'){
            setDlvyMemo('')
        }else{
            setDlvyMemo(e.target.value)
        }                
    };

    const handleTabClick = (tabLabel) => {
        setActiveTab(tabLabel);
        

    };

    const handleKeyPress = (e, next) => {
        if(e.target.value.length === e.target.maxLength){         
            if(next){
                next.current.focus()
            }                           
        }else{
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
              
        }
       
    }

    const handleUseMileage = (e) => {
       const totalMlgAmount = data.totalMlgAmount?data.totalMlgAmount:0
       let lastSetleAmount = Number(data.totGoodsAmount);
       const dlvyCtAmount = Number(data.dlvyPrice);
       const couponDscntAmount = Number(couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0);
       lastSetleAmount += dlvyCtAmount;
       lastSetleAmount -= couponDscntAmount;
       if(lastSetleAmount < useMileage){
            if(useMileage > totalMlgAmount){
                setUseMileage(totalMlgAmount);
            }else{
                setUseMileage(lastSetleAmount);                
            }
       }else{
            if(useMileage > totalMlgAmount){
                setUseMileage(totalMlgAmount);
            }else{
                setUseMileage(useMileage);       
            }
       }
    };

    const fn_selectDlvy = (obj,list) => {
        
        if(obj!=null){
            setDlvyInfo(obj)
        }        
        setData(prevState => ({...prevState, 'dlvyInfoList':list}))
        setDlvyInfo(list.find(item => item.dlvyInfoSn === dlvyInfo?.dlvyInfoSn))
        setDelivOpen(false)
    }
    
    useEffect(() => {
        fetchData();
      }, []);
    return(
        
        <div>
            {data.totGoodsAmount ?(
            <div>
                <div className="backGround bgBlue"></div>
                <Header type="search" pageTitle={t(`Message.order_payment_screen_order_pay`)}/>

                <div className="orderPageWr">
                    <div>
                        <Accordion className="orderAccordion" defaultActiveKey={['0']} alwaysOpen>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <p>{t(`Message.my_order_hist_detail_order_goods`)} <span className="cGreen">{data.goodsOptnInfoList && data.goodsOptnInfoList.length}</span></p>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="orderProdList">
                                        {data.goodsOptnInfoList && data.goodsOptnInfoList.map((obj, index) => (     
                                        <Product2 key={index}
                                            type="type4"
                                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                                            prodName={obj.goodsNm}
                                            option={obj.firstOptnNm + ' ' +obj.firstOptnValue + " X "+  obj?.orderQy}                                       
                                            disprice={"￦"+obj.sleAmount.toLocaleString('ko-KR')}
                                            cost={"￦"+obj.nrmltAmount.toLocaleString('ko-KR')}
                                            qty={obj.orderQy.toLocaleString('ko-KR')}
                                        />
                                        ))}                                     
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>


                    <div className="dfColG8">
                        <p className="title">{t(`Message.ordrr_info_title`)}</p>
                        <div className="ordererInfo">
                            <ul className="info">
                                <li>
                                    <p className="cDisa">{t(`Message.ordrr_info_order`)}</p>
                                    <p className="cBlack">{ordererInfo.userNm}</p>
                                </li>
                                <li>
                                    <p className="cDisa">{t(`Message.ordrr_info_mobile`)}</p>
                                    <p className="cBlack">{ordererInfo.telno}</p>
                                </li>
                                <li>
                                    <p className="cDisa">{t(`Message.ordrr_info_email`)}</p>
                                    <p className="cBlack">{ordererInfo.email}</p>
                                </li>
                            </ul>
                            <button type="button" className="btn2424 pen" onClick={(e)=> setOrdererOpen(true)}><BsFillPenFill /></button>
                        </div>
                    </div>


                    <div className="dfColG8">
                        <p className="title">{t(`Message.dlvy_info_dlvy_info_title`)}</p>
                        
                        <div className="delivInfo">
                            <div className="dfsbG20">
                                <div className="adrBtnWr">
                                    {data.dlvyInfoList && data.dlvyInfoList.map((obj, index) => (   
                                        <button key={index} type="button" onClick={(e)=> {setDlvyInfo(obj); setDlvyCtAmount(data.dlvyPrice + ((obj.extraDlvyCtAmount?obj.extraDlvyCtAmount:0) * 1))}} className={(dlvyInfo?.dlvyInfoSn?dlvyInfo.dlvyInfoSn:0) === obj.dlvyInfoSn?"adrBtn active":"adrBtn"}>{obj.dlvyNcm}</button>
                                    ))}                                    
                                </div>
                                <button type="button" className="btn2424 pen" onClick={(e)=>setDelivOpen(true)}><BsFillPenFill /></button>
                            </div>
                            {!dlvyInfo? (
                                <Nodata text={t(`Message.dlvy_info_list_empty_dlvy`)}/>
                            ) :(   
                            <div className="dfColG8">                            
                                {dlvyInfo.dlvyAtchmnfl?(
                                     <img alt={dlvyInfo.replcTextCn} src={"https://www.salee.co.kr/com/cmm/getDlvyInfoImage.sale?userId="+dlvyInfo.dlvyAtchmnfl.userId+"&dlvyInfoSn="+dlvyInfo.dlvyAtchmnfl.dlvyInfoSn} />
                                ):(
                                <>
                                <p className="nickname">{dlvyInfo.dlvyInfoNm}</p>
                                <p className="tel">{dlvyInfo.dlvyCttpc}</p>
                                <p className="adr">{dlvyInfo.dlvyBassAdres}</p>  
                                </>
                                )}                          
                            </div>
                            )}
                        </div>
                    
                        <div className="delivDt">
                            <p className="tit">{t(`Message.dlvy_etc_info_front_door_pass`)}</p>
                            <input type="text" name="entrncPass" onChange={(e) => { setDlvyInfo(prevState => ({...prevState , 'dlvyEntrncPass':e.target.value })) }} defaultValue ={dlvyInfo?dlvyInfo.dlvyEntrncPass:''}  placeholder={t(`Message.dlvy_etc_info_hint_front_door_pass`)}/>
                        </div>
                        <div className="delivDt">
                            <p className="tit">{t(`Message.dlvy_etc_info_shipping_req_title`)}</p>
                            <select onChange={handleSelect} className="sort">
                            <option value="">{t(`Message.dlvy_etc_info_shipping_req_select`)}</option>
                            <option value="부재시 경비실에 맡겨주세요">{t(`Message.dlvy_etc_info_shipping_req1`)}</option>
                            <option value="부재시 전화주세요">{t(`Message.dlvy_etc_info_shipping_req2`)}</option>
                            <option value="부재시 문앞에 놓아주세요">{t(`Message.dlvy_etc_info_shipping_req3`)}</option>
                            <option value="택배보관함에 맡겨주세요">{t(`Message.dlvy_etc_info_shipping_req4`)}</option>
                            <option value="etc">{t(`Message.dlvy_etc_info_shipping_req5`)}</option>
                            </select>
                            {selMemo !== 'etc'  ? null :(
                            <input type="text" name="dlvyMemo"  defaultValue={dlvyMemo} onChange={(e)=>{setDlvyMemo(e.target.value)}} placeholder={t(`Message.dlvy_etc_info_hint_shipping_req`)}/>
                            )}
                        </div>
                        
                    </div>



                    <div className="dfColG8">
                        <p className="title">{t(`Message.discount_info_title`)}</p>

                        <div className="dfColG4 discountInfo">
                            <div className="mileage">
                                <div className="dfcsG8">
                                    <BsDatabaseFill className="cOrg"/>
                                    <p className="cNavy">{t(`Message.discount_info_mlg`)}</p>
                                    <p className="cBlue">{!data.totalMlgAmount?0:data.totalMlgAmount.toLocaleString('ko-KR')}</p>
                                    <button type="button" className="xBtn" onClick={(e)=> { setUseMileage(0) }} ><BsX /></button>   
                                </div>
                                <div className="useMileage">
                                    <input type="number" name="useMileage" value={useMileage}  onChange={handleUseMileage} />
                                    <button type="button" onClick={(e) => {setUseMileage(data.totalMlgAmount)}} className="btn24 greenB cFFF fs12">{t(`Message.discount_info_full_use`)}</button>
                                </div>
                            </div>
                            <div className="coupon" onClick={(e)=> setCouponOpen(true)}>
                                <div className="dfcsG8">
                                    <BsTags className="cOrg"/>
                                    <p className="cNavy">{t(`Message.discount_info_sale_coupon`)}</p>
                                    <p className="cBlue">-￦{couponInfo.couponDscntAmount?couponInfo.couponDscntAmount.toLocaleString('ko-KR'):0}</p>                                 
                                    <button type="button" className="xBtn" onClick={(e)=> {e.stopPropagation(); setCouponInfo({}) }} ><BsX /></button>   
                                </div>
                                <BsChevronRight onClick={(e)=> setCouponOpen(true)} />
                            </div>
                        </div>
                    </div>


                    <div className="dfColG8">
                        <p className="title">{t(`Message.payment_method_select_title`)}</p>
                        <div className="test">
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a0" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'billing'}) )}} />
                                <label htmlFor="a0">
                                    <BsCashStack className="cOrg"/>
                                    카드 간편결제
                                </label>
                                {cardInfo.payMethod === 'billing'?(
                                <div className="paymentType1">
                                    <div className="wr">          
                                        {easyCardList && easyCardList.length!==0?(                                        
                                        <div className="dfColG20">
                                            {seltEasyCardInfo.billingSn && seltEasyCardInfo.billingSn !== 0?(
                                            <div className="dfColG12">
                                                <p className="seletedCard">{seltEasyCardInfo?.cardName} {seltEasyCardInfo?.cardNum}</p>
                                                <select ref={cardQuota} disabled={(data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)) < 50000}>
                                                    <option value="0">{t(`Message.my_order_detail_payment_info_pay_card_quota1`)}</option>
                                                    {Array(23).fill(0).map((_,i) => (                                                        
                                                        <option key={i+2} value={i+2}>{t(`Message.my_order_detail_payment_info_pay_card_quota2`, {cardQuota: i+2})}</option>
                                                    ))}                                                    
                                                </select>
                                                <p className="cDisa fs12">* 할부는 50,000원 이상만 가능합니다.</p>
                                                
                                            </div>
                                            ):null}
                                            <ul className="payType1radio">
                                                {easyCardList && easyCardList.map((obj, index) => (     
                                                <li key={index}> 
                                                    <input type="radio" name="easyCard" id={"b"+obj.billingSn} onChange={(e)=>setSeltEasyCardInfo(obj)} />
                                                    <label htmlFor={"b"+obj.billingSn}>{obj.cardName} {obj.cardNum}</label>
                                                    <button type="button" className="btn2424 del" onClick={(e)=> fn_removeEasyCard(obj)}><BsFillTrashFill /></button>
                                                </li>
                                                ))}   
                                            </ul>
                                        </div>                                                          
                                         ):(                       
                                        <p className="cDisa">등록된 카드가 없습니다.<br/> 카드를 추가해주세요.</p>                
                                        )} 
                                    </div>
                                    <button 
                                        type="button" 
                                        className="btn40 greenB cFFF"
                                        onClick={(e) => setCardOpen(true)}
                                    >
                                        <BsPlusLg/>카드추가
                                    </button>
                                </div>
                                ):null}
                            </div>
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a1" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'card'}))}} />
                                <label htmlFor="a1">
                                    <BsCreditCard className="cOrg"/>
                                    {t(`Message.payment_method_select_general_card_pay`)}
                                </label>
                            </div>
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a2" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'va'}))}} checked={cardInfo.payMethod=== 'va'}/>
                                <label htmlFor="a2">
                                    <BsWallet className="cOrg"/>
                                    {t(`Message.payment_method_select_virtual_account`)}
                                </label>
                                {cardInfo.payMethod === 'va'?(
                                <div className="paymentType1">
                                    <p className="fs14 cGray">{t(`Message.payment_method_select_virtual_account_info_msg`)}</p>
                                    <div className="hgWr">
                                        <h3 className="tit">현금영수증</h3>
                                        <Tabs
                                            id="controlled-tab-va"
                                            defaultActiveKey={ordererInfo?.cashRcptAt==="Y"?"apply":"noApply"}
                                            onSelect={handleTabClick}
                                            className="hgTab"
                                            >
                                            <Tab eventKey="apply" title="신청">
                                                <div className="dfColG4 myhgInfo">
                                                    {ordererInfo?.cashRcptAt==="Y" && !isCashRcptOpen ?(
                                                        <>
                                                        <div className="dfsbG8">
                                                            <h3 className="fs14">{ordererInfo?.cashRcptPubType===1?"개인소득공제용":"사업자증빙용(세금계산서)"}</h3>
                                                            <button type="button" className="btn2424 pen" onClick={(e)=>setCashRcptOpen(true)}><BsFillPenFill /></button>
                                                        </div>
                                                        <div className="dfcsG12 mhi">
                                                            <p className="fs14 cGray">{ordererInfo?.cashRcptPubType!==2?(ordererInfo.cashRcptPubNoType!==2?"휴대폰번호":"현금영수증 카드번호"):"사업자번호"}</p>
                                                            <p className="fs14 cNavy">{ordererInfo?.cashRcptPubNo}</p>
                                                        </div>
                                                    </>
                                                    ):(
                                                    <div className="dfColG8 mhs">
                                                        <div className="radioWr">
                                                            <input type="radio" name="cashRcptPubType" onChange={(e)=>setCashRcptTy(1)} id="k1" value={1} defaultChecked={ordererInfo?.cashRcptPubType!==2?true:false}/>
                                                            <label htmlFor="k1">개인소득공제용</label>
                                                            <input type="radio" name="cashRcptPubType" onChange={(e)=>setCashRcptTy(2)} id="k2" value={2} defaultChecked={ordererInfo?.cashRcptPubType===2?true:false}/>
                                                            <label htmlFor="k2">사업자증빙용(세금계산서)</label>
                                                        </div>
                                                        {cashRcptTy !==2?(
                                                        <div className="dfColG4">                                                           
                                                            <select className="w100per" value={cashRcptTy2} onChange={(e)=>{ setCashRcptTy2(Number(e.target.value))}} >
                                                                <option value={1}>휴대폰번호</option>
                                                                <option value={2}>현금영수증 카드번호</option>
                                                            </select>
                                                            {cashRcptTy2 === 1?(
                                                            <div className="dfcsG4 ipWr privInput">
                                                                <input type="tel" maxLength="3" ref={phoneInput1} onKeyUp={(e)=>handleKeyPress(e,phoneInput2)} title="휴대폰번호 첫째자리"/>
                                                                <span>-</span>
                                                                <input type="tel" maxLength="4" ref={phoneInput2} onKeyUp={(e)=>handleKeyPress(e,phoneInput3)} title="휴대폰번호 둘째자리"/>
                                                                <span>-</span>
                                                                <input type="tel" maxLength="4" ref={phoneInput3} onKeyUp={(e)=>handleKeyPress(e,null)} title="휴대폰번호 셋째자리"/>
                                                            </div>
                                                            ):null}
                                                            {cashRcptTy2 === 2?(
                                                            <div className="dfcsG4 ipWr privInput">
                                                                <input type="tel" maxLength="4" ref={cardInput1} onKeyUp={(e)=>handleKeyPress(e,cardInput2)} title="현금영수증 카드 번호 첫째자리"/>
                                                                <span>-</span>
                                                                <input type="tel" maxLength="4" ref={cardInput2} onKeyUp={(e)=>handleKeyPress(e,cardInput3)} title="현금영수증 카드 번호 둘째자리"/>
                                                                <span>-</span>
                                                                <input type="tel" maxLength="4" ref={cardInput3} onKeyUp={(e)=>handleKeyPress(e,cardInput4)} title="현금영수증 카드 번호 셋째자리"/>
                                                                <span>-</span>
                                                                <input type="tel" maxLength="4" ref={cardInput4} onKeyUp={(e)=>handleKeyPress(e,null)} title="현금영수증 카드 번호 넷째자리"/>
                                                            </div>
                                                            ):null}
                                                        </div>
                                                        ):(
                                                        <div className="dfcsG4 ipWr compInput">
                                                            <input type="tel" maxLength="3" ref={bizrnoInput1} onKeyUp={(e)=>handleKeyPress(e,bizrnoInput2)} title="사업자등록번호 첫째자리"/>
                                                            <span>-</span>
                                                            <input type="tel" maxLength="2" ref={bizrnoInput2} onKeyUp={(e)=>handleKeyPress(e,bizrnoInput3)} title="사업자등록번호 둘째자리"/>
                                                            <span>-</span>
                                                            <input type="tel" maxLength="5" ref={bizrnoInput3} onKeyUp={(e)=>handleKeyPress(e,null)} title="사업자등록번호 셋째자리"/>
                                                        </div>
                                                        )}

                                                        <div className="chkWr">
		                                    				<input type="checkbox" ref={cashRcptUseAt} name="cashRcptUseAt" id="cashRcptUseAt"/>
		                                    				<label for="cashRcptUseAt">다음에도 사용할게요</label>
		                                    			</div>
                                                    </div>
                                                    )}
                                                </div>
                                            </Tab>
                                            <Tab eventKey="noApply" title="미신청"></Tab>
                                        </Tabs>            
                                    </div>
                                </div>
                                ):null}
                            </div>
                            {/* 
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a3" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'bank'}))}} />
                                <label htmlFor="a3">
                                    <BsBank2 className="cOrg"/>
                                    실시간 계좌이체
                                </label>
                            </div>
                            */}
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a4" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'naverpayCard'}))}} />
                                <label htmlFor="a4">
                                    <img src={naverPay} alt="네이버페이" className="payImg"/>
                                    네이버페이
                                </label>
                            </div>
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a5" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'kakaopay'}))}} />
                                <label htmlFor="a5">
                                    <img src={kakaoPay} alt="카카오페이" className="payImg"/>
                                    카카오페이
                                </label>
                            </div>
                            <div className="paymentType2">
                                <input type="radio" name="pay" id="a6" onChange={(e)=> {  setCardInfo(prevState => ({...prevState , 'payMethod': 'samsungpayCard'}))}} />
                                <label htmlFor="a6">
                                    <img src={ssPay} alt="삼성페이" className="payImg"/>
                                    삼성페이
                                </label>
                            </div>
                        </div>
                       
                    </div>


                    <div className="dfColG20">
                        <ul className="priceDetail">
                            <li>
                                <p className="lc">{t(`Message.last_setle_amount_goods_amt`)}</p>
                                <p className="rc">￦{data.totGoodsAmount.toLocaleString('ko-KR')}</p>
                            </li>                           
                            <li>
                                <p className="lc">{t(`Message.last_setle_amount_dlvy_amt`)}</p>
                                <p className="rc">￦{dlvyCtAmount.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p className="lc">{t(`Message.last_setle_amount_coupon_sle_amt`)}</p>
                                <p className="rc">-￦{couponInfo.couponDscntAmount?couponInfo.couponDscntAmount.toLocaleString('ko-KR'):0}</p>
                            </li>
                            <li>
                                <p className="lc">{t(`Message.last_setle_amount_mlg_use_amt`)}</p>
                                <p className="rc">-￦{useMileage.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p className="lc"></p>
                                <p className="rc">￦{(data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)).toLocaleString('ko-KR')}</p>
                            </li>
                        </ul>
                        <div className="expMilegeWr">
                            <img src={point} alt={t(`Message.my_order_confirm_goods_confirm_mlg`)} />
                            <p className="greenTxt">{data.mlgAccml.toLocaleString('ko-KR')}</p>
                            <p>{t(`Message.order_payment_screen_mlg_point`)}</p>
                        </div>
                              
                        <p className="cNavy fw600 fs12 chkWr"> 
                            <input type="checkbox" name="agr" id="agr" onChange={(e)=>{setAgr(e.target.checked)}}/>
                            <label htmlFor="agr"> {t(`Message.info_agree_msg`)}</label>
                        </p>
                    </div>
                </div>
                <button type="button" className="floatBtn" onClick={(e) => fn_order()}>{(data.totGoodsAmount + dlvyCtAmount - (useMileage+couponInfo.couponDscntAmount?couponInfo.couponDscntAmount:0)).toLocaleString('ko-KR')} {t(`Message.payment_button_paying`)}</button>
            </div>
            ):null}      

            <Modal
                className="centerModal passwordModal"
                size="small"
                show={isEsayPassOpen}
                onHide={setEsayPassOpen}
                backdrop="static"
                centered
                >               
                <div className="modalBody">         
                    <h3 class="fs15 cBlack">간편결제 비밀번호 입력</h3>           
                    <div className="dfccG6 passwordModal">
                    <input type="password" maxLength="1" ref={passInput1} onKeyUp={(e)=>handleKeyPress(e,passInput2)} />
                    <input type="password" maxLength="1" ref={passInput2} onKeyUp={(e)=>handleKeyPress(e,passInput3)} />
                    <input type="password" maxLength="1" ref={passInput3} onKeyUp={(e)=>handleKeyPress(e,passInput4)} />
                    <input type="password" maxLength="1" ref={passInput4} onKeyUp={(e)=>handleKeyPress(e,null)} />
                    </div>
                </div>
                <div className="modalBtnWr">
                <button type="button" className="cancleBtn"
                   onClick={(e)=>setEsayPassOpen(false)} >
                    {t(`Message.common_cancel`)}
                    </button>
                    <button type="button" 
                     onClick={(e)=>fn_Billing()}
                    >
                    {t(`Message.common_ok`)}
                    </button>   
                </div>
            </Modal>
                                
            
            <Modal
                className="btModal"
                show={isOrdererOpen}
                onHide={setOrdererInfo}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
            >
                <OrderModifyOrderer modal={true} setOrdererInfo={setOrdererInfo} userInfo={ordererInfo} closeFn={setOrdererOpen}></OrderModifyOrderer>
            </Modal>
            
            <Modal
                className="btModal"
                show={isDelivOpen}
                onHide={setDelivOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >
                <DelivManagement modal={true} closeFn={setDelivOpen} checkDlvy={dlvyInfo?dlvyInfo.dlvyInfoSn:0} selectDlvy={fn_selectDlvy}></DelivManagement>
            </Modal>

            <Modal
                className="btModal"
                show={isCardOpen}
                onHide={setCardOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >
                <OrderAddCard modal={true} data={data}  setEasyCardList={setEasyCardList} closeFn={setCardOpen}></OrderAddCard>
            </Modal>
            <Modal
                className="btModal"
                show={isCouponOpen}
                onHide={setCouponOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >            
                <OrderCoupon modal={true} dlvyCtAmount={data.dlvyPrice} mlgUseAmount={useMileage} closeFn={setCouponOpen} couponIssuHistSn={couponInfo.couponIssuHistSn?couponInfo.couponIssuHistSn:0} setCouponInfo={setCouponInfo} totGoodsAmount={data.totGoodsAmount} data={data.couponIssuHistList}  ></OrderCoupon>
            </Modal>
        </div>
        
    );
};